import React, { useEffect, useRef, useState } from 'react';

import clsx from 'clsx';
import styled, { css } from 'styled-components';

type Props = {
  className?: string;
  gridTemplateColumns?: string;
  [x: string]: any;
};
export const classes = {
  root: 'NEXYGridWrap',
};
interface WrapStyledGridWrapProps {
  gridTemplateColumns?: string;
  showShadow?: boolean;
}
const WrapStyled = styled.div<WrapStyledGridWrapProps>`
  display: grid;
  overflow-x: auto;
  padding-bottom: 25px;

  ${(props) =>
    props.gridTemplateColumns
      ? css`
          .NEXYCSSGrid {
            //min-width: 100%;
            grid-template-columns: ${props.gridTemplateColumns};
          }
        `
      : undefined}
`;
const ShadowWrapper = styled.div<WrapStyledGridWrapProps>`
  box-shadow: ${({ showShadow }) => (showShadow ? 'inset -7px 0 9px -7px rgba(0,0,0,0.4)' : 'none')};
  transition: 0.2s box-shadow;
`;

function GridWrap({ gridTemplateColumns, className, ...rest }: Props) {
  const scrollContainerRef = useRef();
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const node: HTMLElement | undefined = scrollContainerRef.current;
    if (!node) return;
    checkScroll();
    node.addEventListener('scroll', checkScroll);
    // Scroll alone is not enough: the assistant drawer narrows the grid past its content width
    // without anyone scrolling, and the shadow is the only cue that columns exist off-screen.
    const observer = new ResizeObserver(checkScroll);
    observer.observe(node);
    return () => {
      node.removeEventListener('scroll', checkScroll);
      observer.disconnect();
    };
  }, [scrollContainerRef]);

  const checkScroll = () => {
    // @ts-expect-error
    const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
    const shadowNeeded = scrollWidth > clientWidth;
    setShowShadow(shadowNeeded && scrollLeft < scrollWidth - clientWidth);
  };
  return (
    <ShadowWrapper showShadow={showShadow}>
      <WrapStyled
        ref={scrollContainerRef}
        // showShadow={showShadow}
        gridTemplateColumns={gridTemplateColumns}
        className={clsx(className, classes.root)}
        {...rest}
      />
    </ShadowWrapper>
  );
}

export default GridWrap;
